import React, { useState } from 'react';

import styled from '@emotion/styled';

import CompanyMobileLogo from '../../../components/CompanyLogo/CompanyMobileLogo';
import CloseMenuIcon from '../../../components/Icons/CloseMenuIcon';
import HamburgerIcon from '../../../components/Icons/HamburgerIcon';
import LogOutIcon from '../../../components/Icons/LogOutIcon';
import { NavBoxItem } from '../../../components/Link/Link';
import useOnLogout from '../../../hooks/auth/useOnLogout';
import { navConfig } from './navConfig';

const MobileNav = () => {
  const [navOpen, setNavOpen] = useState(false);
  const { logoutUser } = useOnLogout();

  const handleNavMenuItemClick = (_: any) => {
    setNavOpen(!navOpen);
  };

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  const handleLogout = (e: any) => {
    logoutUser();
  };

  const handleBgClick = (e: any) => {
    setNavOpen(!navOpen);
  };

  return (
    <ContainerWrapper
      className={navOpen ? '' : 'closed-nav'}
      onClick={handleBgClick}
    >
      {!navOpen && (
        <OpenIcon onClick={toggleNav}>
          <HamburgerIcon />
        </OpenIcon>
      )}

      <Container className={navOpen ? '' : 'remove-nav'}>
        <CompanyLogoArea>
          <CompanyMobileLogo />
          <CloseIcon onClick={toggleNav}>
            <CloseMenuIcon />
          </CloseIcon>
        </CompanyLogoArea>

        <NavBtnSection onClick={handleNavMenuItemClick}>
          {navConfig.map((nav) => {
            return (
              <NavBoxItem path={nav.path} key={nav.title} icon={nav.icon}>
                {nav.title}
              </NavBoxItem>
            );
          })}
        </NavBtnSection>

        <Logout onClick={handleLogout}>
          <LogOutIcon /> Logout
        </Logout>
      </Container>
    </ContainerWrapper>
  );
};

export default MobileNav;

const ContainerWrapper = styled.div`
  display: none;
  position: fixed;
  z-index: 2000;
  top: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  transition: background-color 0.35s ease-in-out;

  &.closed-nav {
    width: 0px;
    background-color: rgba(0, 0, 0, 0);
  }

  @media (max-width: 884px) {
    display: flex;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 24px 24px;
  width: 100%;
  width: 347px;
  background-color: ${({ theme }) => theme.palette.lightGrayBg};
  transform: translateX(0);
  transition: transform 0.35s ease-in-out;

  &.remove-nav {
    transform: translateX(-100%);
  }
`;

const NavBtnSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 7px;
  width: 100%;
  padding-top: 24px;
`;

const CompanyLogoArea = styled.div`
  display: flex;
  height: 82px;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  position: relative;
  /* border: 1px solid red; */
`;

const CloseIcon = styled.div`
  padding: 7px;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px #5c59631a;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.palette.lightBorder};
  transition: all 0.2s ease-in-out;
  background-color: ${({ theme }) => theme.palette.lightGrayBg};

  position: absolute;
  right: 20px;

  &:hover {
    transform: translateX(-2px);
  }
`;

const Logout = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  color: ${({ theme }) => theme.palette.logirateBlack};
  font-size: 14px;
  font-weight: 500;
  margin-left: 24px;
  margin-top: auto;
  margin-bottom: 60px;
  cursor: pointer;
`;

const OpenIcon = styled.div`
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  width: fit-content;

  position: absolute;
  right: -43px;
  top: 27px;
  z-index: 10;
  opacity: 0;
  visibility: hidden;

  animation: fadeIn 0.2s ease-in-out 0.3s forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
      visibility: hidden;
    }
    to {
      opacity: 1;
      visibility: visible;
    }
  }

  &:hover {
    transform: translateX(2px);
  }

  & > svg {
    transform: rotate(180deg);
  }
`;
